import { useState } from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import api from '../../../../services/api';

// Modale de confirmation « supprimer tout mon historique » (case à cocher + appel API).
export default function ClearHistoryModal({ scopeId, onClose, onCleared }) {
    const [confirmed, setConfirmed] = useState(false);
    const [clearing, setClearing] = useState(false);

    return (
        <div className="checkout-modal-overlay" onClick={onClose}>
            <div className="checkout-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '420px' }}>
                <div className="checkout-modal__header" style={{ background: 'var(--danger)', color: '#fff' }}>
                    <span className="checkout-modal__title"><AlertTriangle size={18} /> Suppression de l'historique</span>
                </div>
                <div className="checkout-modal__body" style={{ padding: '20px' }}>
                    <p style={{ marginBottom: '12px', fontWeight: 600 }}>
                        Vous &ecirc;tes sur le point de supprimer <strong>tout votre historique</strong> pour cette th&eacute;matique :
                    </p>
                    <ul style={{ fontSize: '0.88em', color: 'var(--text-muted)', marginBottom: '16px', paddingLeft: '20px' }}>
                        <li>Tous vos quiz termin&eacute;s</li>
                        <li>Toutes vos statistiques et scores</li>
                        <li>Votre progression par question</li>
                    </ul>
                    <p style={{ fontSize: '0.85em', color: 'var(--danger)', fontWeight: 600, marginBottom: '16px' }}>
                        Cette action est irr&eacute;versible. Vos donn&eacute;es ne pourront pas &ecirc;tre r&eacute;cup&eacute;r&eacute;es.
                    </p>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '16px', fontSize: '0.88em' }}>
                        <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
                        <span>Je comprends et je souhaite supprimer tout mon historique</span>
                    </label>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                        <button className="btn btn-sm btn-ghost" onClick={onClose}>Annuler</button>
                        <button
                            className="btn btn-sm"
                            style={{ background: 'var(--danger)', color: '#fff' }}
                            disabled={!confirmed || clearing}
                            onClick={async () => {
                                setClearing(true);
                                try {
                                    await api.post('/user/clear-history.php', { scope_id: scopeId });
                                    onClose();
                                    onCleared?.();
                                } catch (err) {
                                    alert(err.response?.data?.message || 'Erreur');
                                }
                                setClearing(false);
                            }}
                        >
                            <Trash2 size={14} /> {clearing ? 'Suppression...' : 'Tout supprimer'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
